import { render, staticRenderFns } from "./ActionsTab_UUID.vue?vue&type=template&id=54fdf97d&scoped=true"
import script from "./ActionsTab_UUID.vue?vue&type=script&lang=js"
export * from "./ActionsTab_UUID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fdf97d",
  null
  
)

export default component.exports